import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HomeSchema from '@/components/feature/HomeSchema';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import WhatIsSection from './components/WhatIsSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import FeaturesSection from './components/FeaturesSection';
import ComparisonTable from './components/ComparisonTable';
import SafetySection from './components/SafetySection';
import ArticleSection from './components/ArticleSection';
import FaqSection from './components/FaqSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = 'VigorBuy Spreadsheet 2026 | Trusted Links, Guides & Reviews';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <HomeSchema />
      <Navbar />

      <main>
        <HeroSection />
        <TrustBar />

        <WhatIsSection />

        <section id="categories" className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                Best Spreadsheet Categories
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto mb-6">
                Browse 14 curated product categories with direct links to trusted resources.
              </p>
              <CategoryDropdown />
            </div>
            <CategoryGrid />
          </div>
        </section>

        <FeaturesSection />
        <ComparisonTable />
        <SafetySection />
        <ArticleSection />
        <FaqSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}